var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconChevronDown(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 7,
    viewBox: "0 0 12 7",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.959995 0.959995C1.1475 0.772727 1.40166 0.667542 1.66666 0.667542C1.93166 0.667542 2.18583 0.772727 2.37333 0.959995L6 4.58666L9.62666 0.959995C9.81623 0.783355 10.067 0.687191 10.326 0.691762C10.5851 0.696333 10.8323 0.801282 11.0155 0.984499C11.1987 1.16772 11.3037 1.4149 11.3082 1.67396C11.3128 1.93303 11.2166 2.18376 11.04 2.37333L6.70666 6.70666C6.51916 6.89393 6.265 6.99911 6 6.99911C5.73499 6.99911 5.48083 6.89393 5.29333 6.70666L0.959995 2.37333C0.772728 2.18583 0.667542 1.93166 0.667542 1.66666C0.667542 1.40166 0.772728 1.1475 0.959995 0.959995Z",
    fill: "#000000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconChevronDown);
export default __webpack_public_path__ + "static/media/icon--chevron-down.1209a6ec1ecf5aab294aa9a153d3774c.svg";
export { ForwardRef as ReactComponent };